import colors from '@/styles/themes/brand/colors';

export const colorVariant = {
  dark: colors.imageBackgroundDark,
  light: colors.imageBackgroundLight,
};
